(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-store"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__astraCartStoreBound) return;
    window.__astraCartStoreBound = true;

    window.AstraTheme = window.AstraTheme || {};

    function getConfig() {
      var el = document.querySelector('[data-astra-cart-config]');
      if (!el) return { strings: {}, moneyFormat: defaultMoneyFormat(), root: '/' };
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return { strings: {}, moneyFormat: defaultMoneyFormat(), root: '/' };
      }
    }

    function defaultMoneyFormat() {
      return '$' + '{' + '{amount}}';
    }

    function routesRoot() {
      var cfg = getConfig();
      if (cfg.root) return cfg.root;
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function formatMoney(cents) {
      var format = getConfig().moneyFormat || defaultMoneyFormat();
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, format);
      }
      var value = (Number(cents) / 100).toFixed(2);
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, value)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
    }

    function syncCount(count) {
      if (typeof window.AstraTheme.syncCartCount === 'function') {
        window.AstraTheme.syncCartCount(count);
      }
    }

    function getThreshold() {
      var node = document.querySelector('[data-astra-free-shipping-threshold]');
      if (!node) return 0;
      return Number(node.getAttribute('data-astra-free-shipping-threshold')) || 0;
    }

    function updateProgress(container, totalPrice) {
      if (!container) return;
      var threshold = getThreshold();
      if (!threshold) {
        container.hidden = true;
        return;
      }
      container.hidden = false;
      var text = container.querySelector('[data-astra-shipping-text]');
      var fill = container.querySelector('[data-astra-shipping-fill]');
      var progress = Math.min(100, (totalPrice * 100) / threshold);
      var remaining = threshold - totalPrice;
      var strings = getConfig().strings || {};
      if (text) {
        if (remaining > 0) {
          text.innerHTML = (strings.freeShippingRemaining || '').replace('__AMOUNT__', formatMoney(remaining));
        } else {
          text.textContent = strings.freeShippingAchieved || '';
        }
      }
      if (fill) fill.style.width = progress + '%';
    }

    function showError(message) {
      var box = document.querySelector('[data-astra-cart-errors]');
      if (box) {
        box.hidden = false;
        box.textContent = message || (getConfig().strings || {}).error || 'Could not update cart';
        return;
      }
      window.alert(message || (getConfig().strings || {}).error || 'Could not update cart');
    }

    function clearError() {
      var box = document.querySelector('[data-astra-cart-errors]');
      if (box) {
        box.hidden = true;
        box.textContent = '';
      }
    }

    function escapeHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildDrawerItem(item, strings) {
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="" width="80" height="100" loading="lazy">'
        : '';
      var variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="astra-cart__item-variant">' + escapeHtml(item.variant_title) + '</p>'
          : '';
      return (
        '<li class="astra-cart__item" data-astra-cart-line data-key="' +
        escapeHtml(item.key) +
        '">' +
        '<a href="' +
        escapeHtml(item.url) +
        '" class="astra-cart__item-image">' +
        image +
        '</a>' +
        '<div class="astra-cart__item-info">' +
        '<a href="' +
        escapeHtml(item.url) +
        '" class="astra-cart__item-title">' +
        escapeHtml(item.product_title || item.title) +
        '</a>' +
        variant +
        '<div class="astra-cart__item-bottom">' +
        '<div class="astra-cart__qty" data-astra-cart-qty>' +
        '<button type="button" class="astra-cart__qty-btn" data-astra-cart-qty-change="-1" aria-label="' +
        escapeHtml(strings.decrease) +
        '">−</button>' +
        '<input class="astra-cart__qty-input" type="number" min="0" value="' +
        item.quantity +
        '" aria-label="' +
        escapeHtml(strings.quantity) +
        '" data-astra-cart-qty-input>' +
        '<button type="button" class="astra-cart__qty-btn" data-astra-cart-qty-change="1" aria-label="' +
        escapeHtml(strings.increase) +
        '">+</button>' +
        '</div>' +
        '<span class="astra-cart__item-price" data-astra-line-price>' +
        formatMoney(item.final_line_price) +
        '</span>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="astra-cart__item-remove" data-astra-cart-remove aria-label="' +
        escapeHtml(strings.remove) +
        '">' +
        '<span aria-hidden="true">×</span>' +
        '</button>' +
        '</li>'
      );
    }

    function renderDrawer(cart) {
      var body = document.querySelector('[data-astra-cart-drawer-body]');
      if (!body) return;
      var strings = getConfig().strings || {};
      var thresholdEnabled = !!document.querySelector('#cart-drawer[data-astra-free-shipping-threshold]');

      if (!cart.item_count) {
        body.innerHTML =
          '<div class="astra-cart__empty">' +
          '<p>' +
          escapeHtml(strings.empty) +
          '</p>' +
          '<a class="astra-btn astra-btn--filled" href="' +
          escapeHtml(routesRoot()) +
          '">' +
          escapeHtml(strings.continue) +
          '</a>' +
          '</div>';
        syncCount(0);
        return;
      }

      var progressHtml = '';
      if (thresholdEnabled) {
        progressHtml =
          '<div class="astra-cart__progress" data-astra-cart-drawer-shipping data-astra-shipping>' +
          '<p class="astra-cart__progress-text" data-astra-shipping-text></p>' +
          '<div class="astra-cart__progress-bar" aria-hidden="true">' +
          '<div class="astra-cart__progress-fill" data-astra-shipping-fill style="width:0%"></div>' +
          '</div></div>';
      }

      var itemsHtml = cart.items
        .map(function (item) {
          return buildDrawerItem(item, strings);
        })
        .join('');

      body.innerHTML =
        progressHtml +
        '<ul class="astra-cart__items" role="list" data-astra-cart-drawer-items>' +
        itemsHtml +
        '</ul>' +
        '<div class="astra-cart__footer">' +
        '<div class="astra-cart__subtotal">' +
        '<span>' +
        escapeHtml(strings.subtotal) +
        '</span>' +
        '<span data-astra-cart-subtotal>' +
        formatMoney(cart.total_price) +
        '</span>' +
        '</div>' +
        '<p class="astra-cart__note">' +
        escapeHtml(strings.taxNote) +
        '</p>' +
        '<a class="astra-btn astra-btn--outline astra-btn--block" href="' +
        escapeHtml(getConfig().cartUrl || '/cart') +
        '">' +
        escapeHtml(strings.view) +
        '</a>' +
        '<form action="' +
        escapeHtml(getConfig().cartUrl || '/cart') +
        '" method="post" class="astra-cart__checkout-form">' +
        '<button type="submit" name="checkout" class="astra-btn astra-btn--filled astra-btn--block">' +
        escapeHtml(strings.checkout) +
        '</button>' +
        '</form>' +
        '</div>';

      updateProgress(body.querySelector('[data-astra-shipping]'), cart.total_price);
      syncCount(cart.item_count);
    }

    function fetchCart() {
      return fetch(routesRoot() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    }

    function changeLine(key, quantity) {
      return fetch(routesRoot() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (response) {
        if (!response.ok) throw new Error('change failed');
        return response.json();
      });
    }

    function afterCartChange(cart) {
      clearError();
      renderDrawer(cart);
      document.querySelectorAll('[data-astra-shipping]').forEach(function (el) {
        updateProgress(el, cart.total_price);
      });
      document.querySelectorAll('[data-astra-cart-page-subtotal]').forEach(function (el) {
        el.textContent = formatMoney(cart.total_price);
      });
      document.querySelectorAll('[data-astra-cart-page-discounts]').forEach(function (wrap) {
        if (!cart.cart_level_discount_applications || !cart.cart_level_discount_applications.length) {
          wrap.hidden = true;
          wrap.innerHTML = '';
          return;
        }
        wrap.hidden = false;
        wrap.innerHTML = cart.cart_level_discount_applications
          .map(function (d) {
            return (
              '<div class="astra-cart__summary-row astra-cart__summary-row--discount">' +
              '<span>' +
              escapeHtml(d.title) +
              '</span>' +
              '<strong>−' +
              formatMoney(d.total_allocated_amount) +
              '</strong></div>'
            );
          })
          .join('');
      });
      document.dispatchEvent(new CustomEvent('astra:cart:updated', { detail: cart }));
    }

    window.AstraTheme.formatMoney = formatMoney;
    window.AstraTheme.refreshCartDrawer = function () {
      return fetchCart().then(function (cart) {
        afterCartChange(cart);
        return cart;
      });
    };
    window.AstraTheme.changeCartLine = function (key, quantity) {
      return changeLine(key, quantity).then(function (cart) {
        afterCartChange(cart);
        return cart;
      });
    };

    document.addEventListener('click', function (event) {
      var qtyBtn = event.target.closest('[data-astra-cart-qty-change]');
      var removeBtn = event.target.closest('[data-astra-cart-remove]');
      var line = event.target.closest('[data-astra-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      if (!key) return;

      if (removeBtn) {
        event.preventDefault();
        line.classList.add('is-loading');
        window.AstraTheme.changeCartLine(key, 0)
          .then(function (cart) {
            if (document.body.contains(line) && cart.item_count > 0) {
              /* drawer re-rendered; page line remove */
            }
            var pageLine = document.querySelector(
              '[data-astra-cart-page] [data-astra-cart-line][data-key="' + key + '"]'
            );
            if (pageLine) {
              if (cart.item_count === 0) {
                window.location.reload();
                return;
              }
              pageLine.remove();
            }
          })
          .catch(function () {
            line.classList.remove('is-loading');
            showError();
          });
        return;
      }

      if (qtyBtn) {
        event.preventDefault();
        var input = line.querySelector('[data-astra-cart-qty-input]');
        var delta = Number(qtyBtn.getAttribute('data-astra-cart-qty-change')) || 0;
        var next = Math.max(0, (parseInt(input && input.value, 10) || 1) + delta);
        line.classList.add('is-loading');
        window.AstraTheme.changeCartLine(key, next)
          .then(function (cart) {
            if (cart.item_count === 0 && document.querySelector('[data-astra-cart-page]')) {
              window.location.reload();
              return;
            }
            var pageLine = document.querySelector(
              '[data-astra-cart-page] [data-astra-cart-line][data-key="' + key + '"]'
            );
            if (pageLine) {
              if (next === 0) {
                pageLine.remove();
                return;
              }
              var pageInput = pageLine.querySelector('[data-astra-cart-qty-input]');
              var pagePrice = pageLine.querySelector('[data-astra-line-price]');
              var updated = cart.items.find(function (i) {
                return i.key === key;
              });
              if (pageInput) pageInput.value = String(next);
              if (pagePrice && updated) pagePrice.textContent = formatMoney(updated.final_line_price);
              pageLine.classList.remove('is-loading');
            }
          })
          .catch(function () {
            line.classList.remove('is-loading');
            showError();
          });
      }
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-astra-cart-qty-input]');
      if (!input) return;
      var line = input.closest('[data-astra-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var next = Math.max(0, parseInt(input.value, 10) || 0);
      line.classList.add('is-loading');
      window.AstraTheme.changeCartLine(key, next)
        .then(function (cart) {
          if (cart.item_count === 0 && document.querySelector('[data-astra-cart-page]')) {
            window.location.reload();
            return;
          }
          var pageLine = document.querySelector(
            '[data-astra-cart-page] [data-astra-cart-line][data-key="' + key + '"]'
          );
          if (pageLine && next === 0) {
            pageLine.remove();
            return;
          }
          if (pageLine) {
            var updated = cart.items.find(function (i) {
              return i.key === key;
            });
            var pagePrice = pageLine.querySelector('[data-astra-line-price]');
            if (pagePrice && updated) pagePrice.textContent = formatMoney(updated.final_line_price);
            pageLine.classList.remove('is-loading');
          }
        })
        .catch(function () {
          line.classList.remove('is-loading');
          showError();
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-behavior"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__astraQuickAddBound) return;
    window.__astraQuickAddBound = true;

    function hydrate(root) {
      root.querySelectorAll('.astra-product-card__img:not(.is-loaded)').forEach(image => {
        if (image.dataset.loadingBound) return;
        image.dataset.loadingBound = 'true';
        const reveal = () => image.classList.add('is-loaded');
        if (image.tagName !== 'IMG' || image.complete) reveal();
        else { image.addEventListener('load', reveal, { once: true }); image.addEventListener('error', reveal, { once: true }); }
      });
    }
    function initialize(root) {
      hydrate(root);
      window.AstraWishlist?.sync?.();
    }
    initialize(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('astra:cards:rendered', event => initialize(event.target));

    function state(button, value) {
      button.classList.toggle('is-loading', value === 'loading');
      button.classList.toggle('is-success', value === 'success');
      button.disabled = value === 'loading';
      [['label', value !== 'loading' && value !== 'success'], ['adding', value === 'loading'], ['added', value === 'success']].forEach(([name, visible]) => {
        const label = button.querySelector('[data-astra-quick-add-' + name + ']');
        if (label) { label.classList.remove('visually-hidden'); label.hidden = !visible; }
      });
    }

    document.addEventListener('submit', async event => {
      const form = event.target.closest('.astra-product-card__form');
      if (!form) return;
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      const button = form.querySelector('[data-astra-quick-add-btn]');
      if (!button || !form.reportValidity()) return;
      const root = window.Shopify?.routes?.root || '/';
      const labels = document.querySelector('[data-astra-card-messages]')?.dataset || {};
      let message = form.querySelector('[data-card-message]');
      if (!message) {
        message = document.createElement('p'); message.dataset.cardMessage = ''; message.setAttribute('role', 'status'); form.append(message);
      }
      message.hidden = true;
      form.dataset.submitting = 'true';
      state(button, 'loading');
      let added = false;
      let rejection = '';
      try {
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          rejection = typeof error.description === 'string' ? error.description : '';
          throw new Error('Add rejected');
        }
        added = true;
        const responseCart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!responseCart.ok) throw new Error('Cart unavailable');
        const cart = await responseCart.json();
        window.AstraTheme?.syncCartCount?.(cart.item_count);
        if (window.AstraTheme?.refreshCartDrawer) {
          await window.AstraTheme.refreshCartDrawer();
          document.querySelector('[data-astra-drawer-open="cart-drawer"]')?.click();
        }
        state(button, 'success');
      } catch (error) {
        message.textContent = added ? labels.refreshError : rejection || labels.error;
        const link = document.createElement('a'); link.href = root + 'cart'; link.textContent = labels.cartLabel;
        message.append(document.createTextNode(' '), link); message.hidden = false;
        state(button, added ? 'success' : 'idle');
      } finally {
        form.dataset.submitting = 'false'; button.disabled = false;
        if (added) window.setTimeout(() => { if (form.dataset.submitting !== 'true') state(button, 'idle'); }, 1800);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-product-share')) {
    customElements.define(
      'astra-product-share',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const input = this.querySelector('[data-share-url]');
          const status = this.querySelector('[data-share-status]');
          const updateLinks = () => {
            const shareUrl = new URL(input.defaultValue);
            shareUrl.search = '';
            shareUrl.hash = '';
            const variant = new URL(window.location.href).searchParams.get('variant');
            if (variant && /^\d+$/.test(variant)) shareUrl.searchParams.set('variant', variant);
            input.value = shareUrl.href;
            this.querySelectorAll('[data-share-param]').forEach((link) => {
              const destination = new URL(link.href);
              destination.searchParams.set(link.dataset.shareParam, shareUrl.href);
              link.href = destination.href;
            });
          };
          updateLinks();
          document.addEventListener('astra:variant-change', updateLinks, options);
          this.querySelector('[data-share-copy]').addEventListener(
            'click',
            async () => {
              updateLinks();
              try {
                await navigator.clipboard.writeText(input.value);
                status.textContent = status.dataset.success;
              } catch (error) {
                input.focus();
                input.select();
                status.textContent = status.dataset.error;
              }
            },
            options
          );
        }
        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-zoom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('astra-product-zoom')) {
    customElements.define('astra-product-zoom', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const root = this.closest('[data-astra-product]');
        const dialog = this.querySelector('dialog');
        const canvas = this.querySelector('[data-zoom-canvas]');
        const toggle = this.querySelector('[data-zoom-toggle]');
        if (!root || !dialog) return;
        const triggers = [...root.querySelectorAll('[data-astra-zoom-open]')];
        const navigation = this.querySelector('[data-zoom-navigation]');
        const counter = this.querySelector('[data-zoom-counter]');
        let index = 0;
        const showImage = (next) => {
          index = (next + triggers.length) % triggers.length;
          const trigger = triggers[index];
          if (!trigger) return;
          const picture = new Image();
          picture.alt = trigger.dataset.zoomAlt || '';
          picture.src = trigger.dataset.zoomSrc;
          canvas.replaceChildren(picture);
          canvas.classList.remove('is-zoomed');
          toggle.setAttribute('aria-pressed', 'false');
          toggle.textContent = toggle.dataset.labelIn;
          canvas.scrollTo(0, 0);
          counter.textContent = `${index + 1} / ${triggers.length}`;
          navigation.hidden = triggers.length < 2;
        };
        root.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-astra-zoom-open]') || (event.target.matches('.astra-product__media img') && event.target.closest('.astra-product__media').querySelector('[data-astra-zoom-open]'));
          if (!trigger) return;
          this.trigger = trigger;
          showImage(triggers.indexOf(trigger));
          dialog.showModal();
        }, options);
        this.querySelectorAll('[data-zoom-step]').forEach(button => button.addEventListener('click', () => showImage(index + Number(button.dataset.zoomStep)), options));
        dialog.addEventListener('keydown', event => {
          if (canvas.classList.contains('is-zoomed')) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          showImage(event.key === 'Home' ? 0 : event.key === 'End' ? triggers.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        let touchStart;
        canvas.addEventListener('touchstart', event => {
          touchStart = null;
          if (!canvas.classList.contains('is-zoomed') && event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { ...options, passive: true });
        canvas.addEventListener('touchend', event => {
          if (!touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(index + (dx < 0 ? 1 : -1));
        }, { ...options, passive: true });
        canvas.addEventListener('touchcancel', () => { touchStart = null; }, options);
        this.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', () => {
          canvas.replaceChildren();
          if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
        }, options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, options);
        toggle.addEventListener('click', () => {
          const zoomed = canvas.classList.toggle('is-zoomed');
          toggle.setAttribute('aria-pressed', String(zoomed));
          toggle.textContent = zoomed ? toggle.dataset.labelOut : toggle.dataset.labelIn;
          requestAnimationFrame(() => canvas.scrollTo(zoomed ? (canvas.scrollWidth - canvas.clientWidth) / 2 : 0, zoomed ? (canvas.scrollHeight - canvas.clientHeight) / 2 : 0));
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        const dialog = this.querySelector('dialog');
        if (dialog?.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recently-viewed-store"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.AstraRecentlyViewed) return;

    var STORAGE_KEY = 'astra-recently-viewed-v1';
    var MAX_ITEMS = 16;

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function read() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter(item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle)).slice(0, MAX_ITEMS) : [];
      } catch (error) {
        return [];
      }
    }

    function write(items) {
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (error) { return; }
      window.dispatchEvent(new CustomEvent('astra:recently-viewed:change', { detail: { items: items } }));
    }

    function track(entry) {
      if (!entry || !entry.handle) return;
      var items = read().filter(function (item) {
        return item.handle !== entry.handle;
      });
      items.unshift({
        handle: entry.handle,
        url: entry.url || '',
        title: entry.title || '',
        image: entry.image || '',
        viewed_at: Date.now()
      });
      write(items.slice(0, MAX_ITEMS));
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function moneyFromCents(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.themeMoneyFormat || undefined);
      }
      const currency = document.querySelector('[data-astra-recently-viewed]')?.dataset.currency || window.Shopify?.currency?.active;
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(cents) / 100); } catch (error) { return (Number(cents) / 100).toFixed(2); }
    }

    function trackFromDom() {
      var node = document.querySelector('[data-astra-rv-track]');
      if (!node) return;
      track({
        handle: node.getAttribute('data-handle'),
        url: node.getAttribute('data-url'),
        title: node.getAttribute('data-title'),
        image: node.getAttribute('data-image')
      });
    }

    function buildCard(product, options) {
      var image =
        product.featured_image ||
        (product.images && product.images[0]) ||
        '';
      var price = moneyFromCents(product.price_min || product.price || 0);
      var compare = product.compare_at_price_min || product.compare_at_price || 0;
      var variants = product.variants || [];
      var canQuickAdd =
        options.showQuickAdd &&
        product.available &&
        variants.length === 1;
      var wishlistHtml = '';

      if (options.showWishlist) {
        wishlistHtml =
          '<div class="astra-product-card__wishlist">' +
          '<button type="button" class="astra-wishlist-btn" data-astra-wishlist-toggle' +
          ' data-product-handle="' +
          escapeHtml(product.handle) +
          '" data-product-url="' +
          escapeHtml(product.url) +
          '" data-product-title="' +
          escapeHtml(product.title) +
          '" data-product-price="' +
          escapeHtml(price) +
          '"' +
          (image ? ' data-product-image="' + escapeHtml(image) + '"' : '') +
          ' aria-pressed="false" aria-label="' +
          escapeHtml(options.addLabel) +
          '">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="16" height="16" aria-hidden="true">' +
          '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 16.25s-5.625-3.2-5.625-7.031A3.281 3.281 0 0 1 10 6.25a3.281 3.281 0 0 1 5.625 2.969C15.625 13.05 10 16.25 10 16.25Z"/>' +
          '</svg>' +
          '<span class="visually-hidden" data-wishlist-label-add>' +
          escapeHtml(options.addLabel) +
          '</span>' +
          '<span class="visually-hidden" data-wishlist-label-remove>' +
          escapeHtml(options.removeLabel) +
          '</span>' +
          '</button></div>';
      }

      var quickAddHtml = '';
      if (options.showQuickAdd) {
        if (canQuickAdd) {
          quickAddHtml =
            '<div class="astra-product-card__quick-add">' +
            '<form class="astra-product-card__form" action="' +
            escapeHtml(routesRoot() + 'cart/add') +
            '" method="post">' +
            '<input type="hidden" name="id" value="' +
            escapeHtml(variants[0].id) +
            '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="astra-btn astra-btn--filled astra-btn--sm astra-product-card__add-btn" data-astra-quick-add-btn>' +
            '<span data-astra-quick-add-label>' +
            escapeHtml(options.addToCartLabel) +
            '</span>' +
            '<span hidden data-astra-quick-add-adding>' +
            escapeHtml(options.addingLabel) +
            '</span>' +
            '<span hidden data-astra-quick-add-added>' +
            escapeHtml(options.addedLabel) +
            '</span>' +
            '</button></form></div>';
        } else if (product.available) {
          quickAddHtml =
            '<div class="astra-product-card__quick-add">' +
            '<a href="' +
            escapeHtml(product.url) +
            '" class="astra-btn astra-btn--filled astra-btn--sm astra-product-card__add-btn">' +
            escapeHtml(options.chooseOptionsLabel) +
            '</a></div>';
        }
      }

      var priceHtml =
        compare > (product.price_min || product.price || 0)
          ? '<div class="astra-price"><span class="astra-price__sale">' +
            escapeHtml(price) +
            '</span> <s class="astra-price__compare">' +
            escapeHtml(moneyFromCents(compare)) +
            '</s></div>'
          : '<div class="astra-price"><span class="astra-price__regular">' +
            escapeHtml(price) +
            '</span></div>';

      return (
        '<article class="astra-product-card" data-product-card data-product-id="' +
        escapeHtml(product.id) +
        '">' +
        '<a href="' +
        escapeHtml(product.url) +
        '" class="astra-product-card__link"><span class="visually-hidden">' +
        escapeHtml(product.title) +
        '</span></a>' +
        '<div class="astra-product-card__media">' +
        (image
          ? '<img src="' +
            escapeHtml(image) +
            '" alt="" class="astra-product-card__img" loading="lazy" width="600" height="800">'
          : '') +
        wishlistHtml +
        quickAddHtml +
        '</div>' +
        '<div class="astra-product-card__info">' +
        '<h3 class="astra-heading astra-heading--card astra-product-card__title"><a href="' +
        escapeHtml(product.url) +
        '">' +
        escapeHtml(product.title) +
        '</a></h3>' +
        priceHtml +
        '</div></article>'
      );
    }

    function renderSections() {
      document.querySelectorAll('[data-astra-recently-viewed]').forEach(function (root) {
        var grid = root.querySelector('[data-astra-rv-grid]');
        if (!grid) return;

        var requestId = (root.astraRequestId || 0) + 1;
        root.astraRequestId = requestId;
        var limit = Math.min(12, Math.max(1, Number(root.dataset.limit || 8)));
        var exclude = root.dataset.excludeHandle || '';
        var items = read()
          .filter(function (item) {
            return item.handle && item.handle !== exclude;
          })
          .slice(0, limit);

        if (!items.length) {
          root.setAttribute('hidden', '');
          grid.innerHTML = '';
          return;
        }

        root.removeAttribute('hidden');
        grid.innerHTML =
          '<p class="astra-recently-viewed__loading">' +
          escapeHtml(root.dataset.loadingLabel || 'Loading…') +
          '</p>';

        var options = {
          showQuickAdd: root.dataset.showQuickAdd === 'true',
          showWishlist: root.dataset.showWishlist === 'true',
          addLabel: root.dataset.wishlistAddLabel || 'Add to wishlist',
          removeLabel: root.dataset.wishlistRemoveLabel || 'Remove from wishlist',
          addToCartLabel: root.dataset.addToCartLabel || 'Add to cart',
          addingLabel: root.dataset.addingLabel || 'Adding…',
          addedLabel: root.dataset.addedLabel || 'Added',
          chooseOptionsLabel: root.dataset.chooseOptionsLabel || 'Choose options'
        };

        Promise.all(
          items.map(function (item) {
            return fetch(routesRoot() + 'products/' + encodeURIComponent(item.handle) + '.js')
              .then(function (response) {
                if (!response.ok) throw new Error('missing');
                return response.json();
              })
              .catch(function () {
                return null;
              });
          })
        ).then(function (products) {
          if (!root.isConnected || root.astraRequestId !== requestId) return;
          var html = products
            .filter(Boolean)
            .map(function (product) {
              return buildCard(product, options);
            })
            .join('');

          if (!html) {
            root.setAttribute('hidden', '');
            grid.innerHTML = '';
            return;
          }

          grid.innerHTML = html;
          root.dispatchEvent(new CustomEvent('astra:cards:rendered', { bubbles: true }));
        });
      });
    }

    window.AstraRecentlyViewed = {
      read: read,
      track: track,
      render: renderSections
    };

    function initialize() { trackFromDom(); renderSections(); window.addEventListener('astra:recently-viewed:change', renderSections); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', renderSections);
    window.addEventListener('storage', event => { if (event.key === STORAGE_KEY) renderSections(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist-store"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.AstraWishlist) return;

    var STORAGE_KEY = 'astra-wishlist-v1';

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function read() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        var parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    function write(items) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('astra:wishlist:change', { detail: { items: items } }));
    }

    function has(handle) {
      return read().some(function (item) {
        return item.handle === handle;
      });
    }

    function toggleItem(entry) {
      if (!entry || !entry.handle) return false;
      var items = read();
      var index = items.findIndex(function (item) {
        return item.handle === entry.handle;
      });
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift(entry);
      }
      write(items);
      return index < 0;
    }

    function remove(handle) {
      write(
        read().filter(function (item) {
          return item.handle !== handle;
        })
      );
    }

    function updateCounts() {
      var count = read().length;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = String(count);
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    }

    function syncButtons() {
      document.querySelectorAll('[data-astra-wishlist-toggle]').forEach(function (button) {
        var handle = button.getAttribute('data-product-handle');
        var active = has(handle);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        var addLabel = button.querySelector('[data-wishlist-label-add]');
        var removeLabel = button.querySelector('[data-wishlist-label-remove]');
        if (addLabel && removeLabel) {
          button.setAttribute('aria-label', active ? removeLabel.textContent : addLabel.textContent);
        }
      });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function moneyFromCents(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, window.themeMoneyFormat || undefined);
      }
      return (Number(cents) / 100).toFixed(2);
    }

    function renderPage() {
      var root = document.querySelector('[data-astra-wishlist-page]');
      if (!root) return;

      var grid = root.querySelector('[data-astra-wishlist-grid]');
      var empty = root.querySelector('[data-astra-wishlist-empty]');
      var items = read();

      if (!grid) return;

      if (!items.length) {
        grid.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      grid.innerHTML =
        '<p class="astra-wishlist-page__loading">' +
        escapeHtml(root.dataset.loadingLabel || 'Loading…') +
        '</p>';

      Promise.all(
        items.map(function (item) {
          return fetch(routesRoot() + 'products/' + encodeURIComponent(item.handle) + '.js')
            .then(function (response) {
              if (!response.ok) throw new Error('missing');
              return response.json();
            })
            .then(function (product) {
              return { ok: true, product: product, fallback: item };
            })
            .catch(function () {
              return { ok: false, fallback: item };
            });
        })
      ).then(function (results) {
        var html = results
          .map(function (result) {
            if (result.ok) {
              var product = result.product;
              var image =
                product.featured_image ||
                (product.images && product.images[0]) ||
                '';
              var price = moneyFromCents(product.price_min || product.price || 0);
              return (
                '<article class="astra-wishlist-page__card" data-wishlist-item="' +
                escapeHtml(product.handle) +
                '">' +
                '<button type="button" class="astra-wishlist-page__remove" data-wishlist-remove="' +
                escapeHtml(product.handle) +
                '" aria-label="' +
                escapeHtml(root.dataset.removeLabel || 'Remove') +
                '">×</button>' +
                '<a class="astra-wishlist-page__media" href="' +
                escapeHtml(product.url) +
                '">' +
                (image
                  ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="400" height="500">'
                  : '') +
                '</a>' +
                '<div class="astra-wishlist-page__info">' +
                '<h2 class="astra-heading astra-heading--card"><a href="' +
                escapeHtml(product.url) +
                '">' +
                escapeHtml(product.title) +
                '</a></h2>' +
                '<p class="astra-wishlist-page__price">' +
                escapeHtml(price) +
                '</p>' +
                '<a class="astra-btn astra-btn--filled astra-btn--sm" href="' +
                escapeHtml(product.url) +
                '">' +
                escapeHtml(root.dataset.viewLabel || 'View product') +
                '</a>' +
                '</div></article>'
              );
            }

            var fallback = result.fallback;
            return (
              '<article class="astra-wishlist-page__card" data-wishlist-item="' +
              escapeHtml(fallback.handle) +
              '">' +
              '<button type="button" class="astra-wishlist-page__remove" data-wishlist-remove="' +
              escapeHtml(fallback.handle) +
              '">×</button>' +
              '<a class="astra-wishlist-page__media" href="' +
              escapeHtml(fallback.url || '#') +
              '">' +
              (fallback.image
                ? '<img src="' + escapeHtml(fallback.image) + '" alt="" loading="lazy">'
                : '') +
              '</a>' +
              '<div class="astra-wishlist-page__info">' +
              '<h2 class="astra-heading astra-heading--card">' +
              escapeHtml(fallback.title || fallback.handle) +
              '</h2>' +
              '<button type="button" class="astra-btn astra-btn--outline astra-btn--sm" data-wishlist-remove="' +
              escapeHtml(fallback.handle) +
              '">' +
              escapeHtml(root.dataset.removeLabel || 'Remove') +
              '</button>' +
              '</div></article>'
            );
          })
          .join('');

        grid.innerHTML = html;
      });
    }

    document.addEventListener('click', function (event) {
      var toggleBtn = event.target.closest('[data-astra-wishlist-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        event.stopPropagation();
        toggleItem({
          handle: toggleBtn.getAttribute('data-product-handle'),
          url: toggleBtn.getAttribute('data-product-url'),
          title: toggleBtn.getAttribute('data-product-title'),
          price: toggleBtn.getAttribute('data-product-price'),
          image: toggleBtn.getAttribute('data-product-image')
        });
        syncButtons();
        updateCounts();
        return;
      }

      var removeBtn = event.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        event.preventDefault();
        remove(removeBtn.getAttribute('data-wishlist-remove'));
        syncButtons();
        updateCounts();
        renderPage();
      }
    });

    window.addEventListener('astra:wishlist:change', function () {
      syncButtons();
      updateCounts();
      renderPage();
    });

    window.AstraWishlist = {
      read: read,
      has: has,
      toggle: toggleItem,
      remove: remove,
      sync: function () {
        syncButtons();
        updateCounts();
        renderPage();
      }
    };

    document.addEventListener('DOMContentLoaded', function () {
      syncButtons();
      updateCounts();
      renderPage();
    });

    syncButtons();
    updateCounts();
    renderPage();
  })();
  } catch(e) { console.error(e); }
})();

})();
